import { put, takeLatest, select, cancel } from 'redux-saga/effects';
import { merge } from 'lodash';

import {
  paginatedConsts as reqCommunities,
  paginatedActions,
} from '../reqDiscoverCommunities';
import {
  makeDiscoverCommunitiesCounterSelector,
  makeDiscoverCommunitiesListSelector,
  makeDiscoverCommunitiesPaginationSelector,
} from '../selectors/selectors';

function* discoverCommunitiesWorker({ payload: { type } }) {
  const paginationOptions = yield select(
    makeDiscoverCommunitiesPaginationSelector(type),
  );
  const communitiesTotal = yield select(
    makeDiscoverCommunitiesCounterSelector(type),
  );
  const existingCommunities = yield select(
    makeDiscoverCommunitiesListSelector(type),
  );

  if (communitiesTotal <= existingCommunities.length) {
    yield cancel();
  }

  const params = merge({}, paginationOptions, {
    type,
    offset: existingCommunities.length,
  });

  yield put(paginatedActions.updatePaginationParameters(params));

  yield put({
    type: reqCommunities.SEND,
    payload: params,
  });
}

export default function* discoverCommunitiesSaga() {
  yield takeLatest(
    reqCommunities.LOAD_NEXT_COMMUNITIES,
    discoverCommunitiesWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/communities/sagas/discoverCommunities.js